import axios from './instanceAxios'
import {
	interfaceSwBranch,
	interfaceSwtopmenu,
	interfaceSwnavigationBar,
	interfaceSwBanner,
	interfaceSwNotice,
	interfaceSwNoticeInfo,
	interfaceSwLogo,
	interfaceSwscrollchart,
	interfaceSwadvertisement,
	interfaceSwArticle,
	interfaceSwArticleReadNum,
	interfaceSwMeet,
	interfaceSwMeetInfo,
	interfaceLogin,
	interfaceRegister,
	interfaceGetUserInfo
} from "./interface";

// 获取专区分会
export const getSwBranchList = (params) => {
	return axios({
		url: interfaceSwBranch,
		method: 'get',
		params
	})
}

// 获取上浮菜单
export const getSwtopmenuList = (params) => {
	return axios({
		url: interfaceSwtopmenu,
		method: 'get',
		params
	})
}

// 获取导航栏
export const getSwnavigationBar = (params) => {
	return axios({
		url: interfaceSwnavigationBar,
		method: 'get',
		params
	})
}

// 获取banner
export const getSwBanner = (params) => {
	return axios({
		url: interfaceSwBanner,
		method: 'get',
		params
	})
}

// 获取公告
export const getSwNotice = (params) => {
	return axios({
		url: interfaceSwNotice,
		method: 'get',
		params
	})
}

// 获取公告详情 interfaceSwNoticeInfo
export const getSwNoticeInfo = (id) => {
	return axios({
		url: interfaceSwNoticeInfo + id,
		method: 'get'
	})
}

// logo
export const getSwLogo = (params) => {
	return axios({
		url: interfaceSwLogo,
		method: 'get',
		params
	})
}

// 图片滚动区域
export const getSwscrollchart = (params) => {
	return axios({
		url: interfaceSwscrollchart,
		method: 'get',
		params
	})
}

// 广告
export const getSwadvertisement = (params) => {
	return axios({
		url: interfaceSwadvertisement,
		method: 'get',
		params
	})
}

// 文章列表
export const getSwArticle = (params) => {
	return axios({
		url: interfaceSwArticle,
		method: 'get',
		params
	})
}

// 文章列表
export const articleReadNum = (id) => {
	return axios({
		url: `${interfaceSwArticleReadNum}/${id}`,
		method: 'get',
	})
}

// 会议
export const getSwMeet = (params) => {
	return axios({
		url: interfaceSwMeet,
		method: 'get',
		params
	})
}

// 会议详情
export const getSwMeetInfo = (id) => {
	return axios({
		url: `${interfaceSwMeetInfo}/${id}`,
		method: 'get'
	})
}

// 会员登录
export const login = (data) => {
	return axios({
		url: interfaceLogin,
		method: 'post',
		data
	})
}

// 用户更新密码
export const updatePassword = (data) => {
	return axios({
		url: '/strokeuser/userinfo/updatePassword',
		method: 'post',
		data
	})
}

// 获取用户详情
export const getUserInfo = () => {
	return axios({
		url: interfaceGetUserInfo,
		method: 'get'
	})
}

// 会员登录
export const register = (data) => {
	return axios({
		url: interfaceRegister,
		method: 'post',
		data
	})
}

// 获取验证码
export const getSmsCode = (phone, type) => {
	return axios({
		url: `/strokeuser/userinfo/sendSmsCode/${phone}/${type}`,
		method: 'get'
	})
}

// 获取机构列表
export const getOrgListByName = () => {
	return axios({
		url: '/strokeuser/userinfo/getOrgListByName',
		method: 'get'
	})
}

// 字典查询
export const getDictType = (params) => {
	return axios({
		url: '/sys/dict/data/getDictList',
		method: 'get',
		params
	})
}

// 会员完善资料
export const perfectInformation = (data) => {
	return axios({
		url: '/strokeuser/userinfo/perfectInformation',
		method: 'put',
		data
	})
}

// 获取证书列表
export const getCertificate = () => {
	return axios({
		url: '/strokeuser/userinfo/getCertificate',
		method: 'get'
	})
}

// 获取会员等级列表
export const getUserLevel = () => {
	return axios({
		url: '/strokeuser/userinfo/getUserLevel',
		method: 'get'
	})
}

// 获取会员可选的等级列表
export const getUserCanSelectList = () => {
	return axios({
		url: '/strokeuser/userinfo/getUserCanSelectList',
		method: 'get'
	})
}

// 查询微信订单详情
export const getWechatOrderInfo = () => {
	return axios({
		url: '/strokeuser/order/getWechatOrderInfo',
		method: 'get'
	})
}

// 微信统一欲下单
export const getWxPayQrcode = (data) => {
	return axios({
		url: '/strokeuser/order/getWxPayQrcode',
		method: 'post',
		data
	})
}

// 查询缴费记录
export const getOrderPage = (params) => {
	return axios({
		url: '/strokeuser/order/getOrderPage',
		method: 'get',
		params
	})
}

// 关闭微信订单
export const closeOrder = (outTradeNo) => {
	return axios({
		url: `/strokeuser/order/closeOrder/${outTradeNo}`,
		method: 'get'
	})
}

// 获取会员等级详情
export const getUserLevelInfo = (levelId) => {
	return axios({
		url: `/strokeuser/userinfo/getUserLevelInfo/${levelId}`,
		method: 'get'
	})
}

// 保存附件
export const saveFile = (data) => {
	return axios({
		url: '/strokeuser/order/saveFile',
		method: 'post',
		data
	})
}

// 删除附件
export const deleteFileById = (id) => {
	return axios({
		url: `/strokeuser/order/deleteFileById/${id}`,
		method: 'delete'
	})
}

// 广告分页查询
export const getAds = (params) => {
	return axios({
		url: '/sw/swadvertisement/page',
		method: 'get',
		params
	})
}

// 消息中心列表查询
export const getMessageList = () => {
	return axios({
		url: '/strokeuser/userinfo/messageList',
		method: 'get'
	})
}
